import { render, staticRenderFns } from "./Seedbeds.vue?vue&type=template&id=792e8bf6"
import script from "./Seedbeds.vue?vue&type=script&lang=js"
export * from "./Seedbeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports